import { LOCALE_ID, NgModule } from '@angular/core';
import { ExtraFieldValidatonService } from '../shared/services/extra-field-validaton.service';
import { CartResumeService } from '../shared/services/cart-resume.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreConfigurationsService } from '../shared/services/store-configurations.service';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppComponent } from '../app.component';
import { CookieOptions, CookieService } from 'angular2-cookie/core';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { HttpModule } from '@angular/http';
import { ResponsiveModule } from 'ng2-responsive';
import { CommonHttpService } from '../shared/services/http.service';
import { IdentificationStepsService } from '../payment/services/identification-steps.service';
import { NgxMaskModule } from 'ngx-mask';
import { ExtraFieldValidationRuleService } from '../shared/services/extra-field-validation-rule.service';
import { FreightCalculatorService } from '../shared/services/freight-calculator.service';
import { CartItemsService } from '../shared/services/cart-items.service';
import { MobileScrollToService } from '../shared/services/mobile-scroll-to.service';
import { PaymentService } from '../payment/services/payment.service';
import { HttpClientModule } from '@angular/common/http';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { DeliveryStepsService } from '../payment/services/delivery-steps.service';
import { PasswordRecoveryStepsService } from '../payment/services/password-recovery-steps.service';
import { ModalModule } from 'ngx-modialog';
import { ToastrModule } from 'ngx-toastr';
import { CustomFormsModule } from 'ng2-validation';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '../app-routing.module';
import { CartRowsUpdaterService } from './services/cart-rows-updater.service';
import { UnauthenticatedUserRepositoryService } from '../payment/services/unauthenticated-user-repository.service';
import { ResumeUpdaterService } from './services/cart-resume-updater.service';
import { OauthService } from '../shared/services/oauth.service';
import { BrowserModule } from '@angular/platform-browser';
import { DistanceToDeadlineService } from '../payment/services/distance-to-deadline.service';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { PaymentStepsService } from '../payment/services/payment-steps.service';
import { AuthenticatedUserRepositoryService } from '../payment/services/authenticated-user-repository.service';
import { OverlayModule } from 'angular-io-overlay/src/overlay';
import { CartEmptyComponent } from './empty/cart.empty.component';
import { CartRowComponent } from './row/cart.row.component';
import { CartResumeComponent } from './resume/cart.resume.component';
import { CartProceedToPaymentButtonComponent } from './proceed-to-payment-button/cart.proceed-to-payment-button.component';
import { CartComponent } from './cart.component';
import { LoaderModule } from '../shared/components/loader/loader.module';
import { ThumbSourceFactoryService } from '../shared/services/thumb-source-factory.service';
import { CartResumeFreightComponent } from './resume/freight/cart.resume.freight.component';
import { TextMaskModule } from 'angular2-text-mask';
import { GoogleAnalyticsService } from '../shared/services/google-analytics.service';
import { GoogleConversionTagModule } from '../shared/components/google-conversion-tag/google-conversion-tag.module';
import { Rot13Service } from '../shared/services/rot13.service';
import { CartRecurrentComponent } from './recurrent/cart.recurrent.component';
import { CartSubscriptionsUpdateComponent } from './subscriptions-update/cart.subscriptions-update.component';
import { WebpackTranslateLoader } from '../webpack-translate-loader';
import { CartRowExtraFieldsComponent } from './row/extra-fields/cart.row.extra-fields.component';
import { CartRowComponentsComponent } from './row/components/cart.row.components.component';
import { SluggerService } from '../shared/services/slugger.service';
import { FacebookService } from '../shared/services/facebook.service';
import { DataLayerModule } from '../shared/data-layer/data-layer.module';
import { TranslationConfiguratorService } from '../shared/services/translation-configurator.service';
import { LocaleProvider } from '../shared/services/locale.service';
import { CartRowAttributesExtraFieldsComponent } from './row/attributes-extra-fields/cart.row.attributes-extra-fields.component';
import { CartPropertiesComponent } from './properties/cart.properties.component';
import { AppsService } from '../shared/services/apps.service';

@NgModule({
    declarations: [
        CartComponent,
        CartRecurrentComponent,
        CartResumeComponent,
        CartResumeFreightComponent,
        CartRowComponent,
        CartRowExtraFieldsComponent,
        CartRowAttributesExtraFieldsComponent,
        CartRowComponentsComponent,
        CartEmptyComponent,
        CartProceedToPaymentButtonComponent,
        CartSubscriptionsUpdateComponent,
        CartPropertiesComponent
    ],
    imports: [
        LoaderModule,
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader
            }
        }),
        Angular2SocialLoginModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskModule,
        AppRoutingModule,
        OverlayModule,
        CustomFormsModule,
        ResponsiveModule,
        ModalModule.forRoot(),
        BootstrapModalModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-full-width',
            preventDuplicates: true
        }),
        TextMaskModule,
        GoogleConversionTagModule,
        DataLayerModule
    ],
    providers: [
        CookieService,
        CommonHttpService,
        OauthService,
        ThumbSourceFactoryService,
        ExtraFieldValidatonService,
        ExtraFieldValidationRuleService,
        FreightCalculatorService,
        Rot13Service,
        // common services
        CartItemsService,
        CartResumeService,
        MobileScrollToService,
        // cart services
        CartRowsUpdaterService,
        ResumeUpdaterService,
        // payment services
        PaymentStepsService,
        IdentificationStepsService,
        DeliveryStepsService,
        AuthenticatedUserRepositoryService,
        UnauthenticatedUserRepositoryService,
        PasswordRecoveryStepsService,
        PaymentService,
        DistanceToDeadlineService,
        GoogleAnalyticsService,
        FacebookService,
        StoreConfigurationsService,
        AppsService,
        { provide: CookieOptions, useValue: {} },
        LocaleProvider,
        CurrencyPipe,
        SluggerService
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [
        TranslateModule
    ]
})
export class CartModule {

    constructor(
        public translate: TranslateService
    ) {
        translate.use(
            TranslationConfiguratorService.decideUseLanguage(this.translate.getBrowserLang())
        );
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/cart/cart.module.ts